import { clone, isEmpty, reject, uniq } from 'lodash/fp';

import customerActions from '../../actions/customer';
import getProductIdsFromNeeds from '../../utils/get-product-ids-from-needs';
import ProductActions from '../../actions/product';
import ProductService from '.';
import selectCustomer from '../../selectors/select-customer';
import selectIsExcessToggleApplicable from '../../selectors/select-is-excess-toggle-applicable';
import selectProducts from '../../selectors/select-products';

const defaultExcess = '750';

// @ts-expect-error - Automatic, Please fix when editing this file
const fetchProductsFromParams = (state, dispatch, params) => {
  const { needsProductType, needsType, productIds } = params;
  const products = selectProducts(state);

  const productIdsWithExcess = isEmpty(productIds)
    ? getProductIdsFromNeeds({ hospitalExcess: undefined, needsProductType, needsType })
    : clone(productIds);

  const productIdsToLoad = reject(
    (productId) => ProductService.getProduct(products, productId),
    uniq(productIdsWithExcess),
  ) as string[];

  if (!selectIsExcessToggleApplicable(state, undefined) && selectCustomer(state)?.hospitalExcess !== '750') {
    // Always force the user onto $750 excess if they can't change their excess
    dispatch(customerActions.changeHospitalExcess(defaultExcess));
  }

  // If we have no products to load, resolve the promise, else go load em.
  if (isEmpty(productIdsToLoad)) {
    return Promise.resolve();
  }
  // Load the products we don't have.
  const action = ProductActions.load(productIdsToLoad);
  return dispatch(action);
};

export default fetchProductsFromParams;
